import { IntegrationsContactTypes } from '@features/Settings/enums/IntegrationsEnums.ts';
import { HubspotLogoTyped, OutreachLogoTyped, SalesforceLogoTyped } from '@assets/index.ts';
import  { type FeaturesDto, type IntegrationAccount, LogLevels } from '@types';
import type React from 'react';
import { paintToast } from '@lib/logger/paintToast.ts';
import { writeWarningLog } from '@lib/logger/logWarning.ts';
import { t } from 'i18next';


export const getIntegrationName = (activeTab: string): string => {
  const name = Array.from(activeTab);

  return String(name[0].toUpperCase())
    .concat(activeTab.substring(1, name.length));
};

export const selectIcon = (activeTab: string): string => {
  const integration = activeTab.toUpperCase();
  switch (integration as IntegrationsContactTypes) {
  case IntegrationsContactTypes.Outreach: return OutreachLogoTyped;
  case IntegrationsContactTypes.Hubspot: return  HubspotLogoTyped;
  case IntegrationsContactTypes.Salesforce: return SalesforceLogoTyped;
  }
};

export const defineIntegrationIsConfigured = async (
  integrationName: string,
  integrations: FeaturesDto,
  callback: ()=> Promise<string | IntegrationAccount[]>,
  setterHook:  React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  const isIntegrationOn = integrations[integrationName as keyof FeaturesDto];

  if (!isIntegrationOn) {
    setterHook(false);
    return;
  }

  try {
    const accounts = await callback();
    if (Array.isArray(accounts)) {
      setterHook(accounts.length > 0);
    } else {
      setterHook(false);
    }
  } catch {
    setterHook(false);
  }
};

export async function toastNoAccountWarning (message: string): Promise<void> {
  await writeWarningLog(t('contacts.toast.noIntegration', { lng: 'en' }), 'IntegrationsIUHelpers.toastNoAccountWarning', {});
  paintToast(LogLevels.WARNING, message);
}